import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps'
import { useEffect, useState } from 'react'

interface IGoogleMapsLibraries {
  isLoaded: boolean
  geometryLib: google.maps.GeometryLibrary | null
}

export const useGoogleMapsScript = (): IGoogleMapsLibraries => {
  const geometryLib = useMapsLibrary('geometry')

  return {
    isLoaded: !!geometryLib,
    geometryLib
  }
}

export function useGoogleMapsZoom(): number {
  const map = useMap()
  const [zoom, setZoom] = useState(map?.getZoom() || 10)

  useEffect(() => {
    if (!map) return

    // Listen for zoom changes
    const zoomListener = map.addListener('zoom_changed', () => {
      setZoom(map.getZoom() || 10)
    })

    // Initial zoom
    setZoom(map.getZoom() || 10)

    // Clean up event listener
    return () => {
      google.maps.event.removeListener(zoomListener)
    }
  }, [map])

  return zoom
}
